import { useDispatch } from 'react-redux';
import { color } from '../../../../../../styles/GlobalStyles';
import {
  Icon,
  IconStructureBottomLeft,
  IconStructureBottomRight
} from '../../../../../../styles/Icons';
import { StructureArrow } from '../../../../MyTeamBackofficeStyled';
import { getBottomTeamMember } from '../../../../myTeamBackOffice.actions';
import { Position } from '../../../../myTeamBackOffice.constants';

export const GoBottomButton = ({
  label,
  position,
  isDisabled,
  structureType
}) => {
  const dispatch = useDispatch();
  const goBottom = () => {
    if (isDisabled) return;
    console.log(structureType);
    dispatch(getBottomTeamMember(position, structureType));
  };

  return (
    <StructureArrow disabled={isDisabled} onClick={goBottom}>
      <Icon color={color.colors.primary900}>
        {position === Position.L ? (
          <IconStructureBottomLeft />
        ) : (
          <IconStructureBottomRight />
        )}
      </Icon>
    </StructureArrow>
  );
};
